import KosaHistory from "./KosaHistory";

export default KosaHistory;
